import { createEpicMiddleware } from 'redux-observable'
import rootEpic from 'store/middleware/rootEpic'

const rootEpicMiddleware = createEpicMiddleware(rootEpic)

// if (module.hot) {
//   module.hot.accept('store/middleware/rootEpic', () => {
//     rootEpicMiddleware.replaceEpic(rootEpic)
//   })
// }

export default rootEpicMiddleware



// WEBPACK FOOTER //
// ./src/scripts/store/middleware/epic.js